import { fetchExchanges } from './actions/fetchExchanges';
import { createExchange } from "./actions/createExchange";
import { fetchExchange } from "./actions/fetchExchange";

export const actions = {
    fetchExchanges,
    createExchange,
    fetchExchange,
};
